import { useEffect, type ReactNode } from "react";

const NOINDEX = "noindex, follow";

/**
 * Runtime robots guard for utility/authenticated routes that must never be
 * indexed. Public editorial pages use the full Seo component instead.
 */
export default function NoIndexRobots({ children }: { children: ReactNode }) {
  useEffect(() => {
    let meta = document.querySelector('meta[name="robots"]') as HTMLMetaElement | null;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "robots");
      document.head.appendChild(meta);
    }

    const previous = meta.getAttribute("content");
    meta.setAttribute("content", NOINDEX);

    return () => {
      // Do not clobber a new route's Seo effect if it already replaced us.
      if (meta?.getAttribute("content") !== NOINDEX) return;
      if (previous) meta.setAttribute("content", previous);
      else meta.remove();
    };
  }, []);

  return <>{children}</>;
}
